import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavLinks from '../Navbar/NavLinks';

const Logo = () => (
    <span className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 shadow-soft">
            <svg className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8 6 3 12l5 6" />
                <path d="m16 6 5 6-5 6" />
            </svg>
        </span>
        <span className="text-xl font-extrabold tracking-tight text-ink font-display">
            kesnel<span className="text-brand-600">Digital</span>
        </span>
    </span>
);

const NavBar = () => {
    const [top, setTop] = useState(true);
    const [isOpen, setisOpen] = useState(false);

    function handleClick() {
        setisOpen(!isOpen);
    }

    useEffect(() => {
        const scrollHandler = () => {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);

    return (
        <nav className={`fixed top-0 w-full z-30 transition-all duration-300 ease-in-out ${!top ? 'bg-white/90 backdrop-blur-md border-b border-slatex-200 shadow-soft' : 'bg-transparent'}`}>
            <div className="container-x flex flex-row justify-between items-center h-16 lg:h-20">
                <Link to="/" aria-label="kesnelDigital home">
                    <Logo />
                </Link>

                {/* Desktop links */}
                <div className="hidden lg:flex items-center">
                    <NavLinks />
                </div>

                {/* Mobile toggle */}
                <button
                    className="p-2 rounded-lg lg:hidden text-ink hover:bg-slatex-100 transition"
                    onClick={handleClick}
                    aria-label="Toggle menu"
                >
                    <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        {isOpen ? (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                        ) : (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                        )}
                    </svg>
                </button>
            </div>

            {/* Mobile menu */}
            <div className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out bg-white border-b border-slatex-200 ${isOpen ? 'max-h-96 shadow-soft' : 'max-h-0'}`}>
                <div className="container-x flex flex-col items-stretch gap-1 py-4" onClick={() => setisOpen(false)}>
                    <NavLinks mobile />
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
